$(document).ready(function() {
  if($(".cart-popup-wrapper").length > 0){

    $(".cart-popup__dismiss-button, .cart-popup__close").click(function(){
      $(".cart-popup-wrapper").addClass("cart-popup-wrapper--hidden");
    });

    $("body").click(function(e) {
      if(!$(".cart-popup-wrapper").hasClass("cart-popup-wrapper--hidden")){
        var container = $(".cart-popup-wrapper");
        if (!container.is(event.target) && !container.has(event.target).length){
          container.addClass("cart-popup-wrapper--hidden");
        }
      }
    });

    var Side_cart = {      
      init: function(){   
        $(".custom_add_to_cart").click(function(e){
          e.preventDefault();                  
          $(this).addClass("loaded");
          Side_cart.picks_add_to_cart($(this));
        });

        $(".mulitpal_custom_add_to_cart").click(function(e){
          e.preventDefault();                  
          $(this).addClass("loaded");
          Side_cart.picks_multipal_add_to_cart($(this));
        });

        $(".variant_custom_add_to_cart").click(function(e){
          e.preventDefault();                  
          $(this).addClass("loaded");
          Side_cart.picks_varinat_add_to_cart($(this));
        });

      },
      get_cart_data: function(){        
        setTimeout(function(){
          $.ajax({
            type: "GET",
            dataType: "json",
            url: "/cart.json",
            success: function (data) {
              console.log(data);
              $(".cart-popup-wrapper .cart-popup__cta-link .cart_item").html(data.item_count);
              $(".header__cart-counter").html(data.item_count);     
              $(".cart-popup-wrapper .cart-popup-item").html('');
              let zz = 0;
              for (let i = 0; i < data.items.length; i++) {
                var No = i + 1;                  
                if(data.items[i].variant_title){ var variant_title = " - " + data.items[i].variant_title; }else{ var variant_title = ""; }                  
                $(".cart-popup-wrapper .cart-popup-item").append('<div class="item" data-id="' + data.items[i].id + '" data-line="' + No + '"><div class="cart-popup-item__image-wrapper"><img src="' + data.items[i].image + '" class="cart-popup-item__image"></div><div class="cart-popup-item__description"><div><h3 class="cart-popup-item__title">' + data.items[i].product_title + ' <span>' + variant_title + '</span></h3></div><div class="cart-popup-item__quantity"><span>Qty:</span><span class="item_qty">' + data.items[i].quantity + '</span></div></div></div>');
              }          
              $(".cart-popup-wrapper").removeClass("cart-popup-wrapper--hidden");
              $(".custom_add_to_cart").removeClass("loaded");
              $(".mulitpal_custom_add_to_cart").removeClass("loaded");
              $(".variant_custom_add_to_cart").removeClass("loaded");
            },error: function(){
              $(".cart-popup-wrapper").addClass("cart-popup-wrapper--hidden");
            }
          });
        }, 1500);
      },
      picks_add_to_cart: function($this){
        $.ajax({
          type: "POST",
          dataType: "json",
          url: "/cart/add.js",            
          data: $this.parents("form").serialize(),
          success: function(data){
            Side_cart.get_cart_data();
          }
        });
      },
      picks_multipal_add_to_cart: function($this){
        var i = 0;        
        const object = [];
        var boxlength = $this.parents("form").find(".pro_box_multi_var").find(".prosize").length;
        console.log(boxlength);
        $this.parents("form").find(".pro_box_multi_var").find(".prosize").each(function(){
          i++;
          if($(this).find("input.quanity_input").val() != 0){
            let qty = $(this).find("input.quanity_input").val();
            let var_id = $(this).data("variant-id");
            object.push({quantity:qty,id:var_id})
          } 
          if(i == boxlength){            
            $.ajax({
              type: "POST",
              dataType: "json",
              url: "/cart/add.js",            
              data: {
                items: object
              },
              success: function(data){
                Side_cart.get_cart_data();
              }
            });	             
          }
        });        
      },
      picks_varinat_add_to_cart: function($this){        
        if($this.parents(".prosize").find("input.quanity_input").val() != 0){
          let qty = $this.parents(".prosize").find("input.quanity_input").val();
          console.log(qty);
          let var_id = $this.parents(".prosize").data("variant-id");                    
          console.log(var_id);
          $.ajax({
            type: "POST",
            dataType: "json",
            url: "/cart/add.js",            
            data: "quantity=" + qty + "&id=" + var_id,
            success: function(data){
              Side_cart.get_cart_data();
            }
          });
        } 
      }
    }
    Side_cart.init();
  }
});